var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_light"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65_light",
    cx: 12.2324,
    cy: 12.5,
    r: 3.5,
    stroke: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 66_light",
    d: "M20.4205 11.4343C20.8086 11.9056 21.0027 12.1412 21.0027 12.5C21.0027 12.8588 20.8086 13.0944 20.4205 13.5657C19.0004 15.2899 15.8682 18.5 12.2324 18.5C8.59669 18.5 5.46448 15.2899 4.04439 13.5657C3.65623 13.0944 3.46215 12.8588 3.46215 12.5C3.46215 12.1412 3.65623 11.9056 4.04439 11.4343C5.46448 9.71014 8.59669 6.5 12.2324 6.5C15.8682 6.5 19.0004 9.71014 20.4205 11.4343Z",
    stroke: "#787878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.97b04aaa668e4b846c83ece98782d59e.svg";
export { ForwardRef as ReactComponent };